export default __webpack_public_path__ + "static/pdp-cord-4a89c95dbdf11f4fbc5343ca5ac9b525.svg";